import React, { Fragment, } from "react";
import { Tab as BSTab, Nav, NavItem } from "react-bootstrap";
import { Title } from "./Title";
import { IconOptions } from "./utils/iconOptions";
export const TabContainer = ({ defaultTab, id, children, activeTab, onChange, className }) => {
    return (React.createElement(BSTab.Container, { id: id, defaultActiveKey: defaultTab, activeKey: activeTab, onSelect: onChange, className: className },
        React.createElement(BSTab.Content, { animation: false }, children)));
};
export const TabMenu = ({ items, type = "horizontal", title = "", titleLevel = "h3", headerLeftExtra, children, dataHook, }) => {
    let className = undefined;
    if (type === "bar") {
        className = "tab-nav-bar";
    }
    return (React.createElement(Nav, { bsStyle: "tabs", stacked: type === "stacked", bsClass: className, "data-hook": dataHook },
        title && (React.createElement(Title, { titleLevel: titleLevel },
            React.createElement(Fragment, null, title))),
        headerLeftExtra && (React.createElement("div", { className: "ml-2 mr-auto flex-grow" }, headerLeftExtra)),
        items.map((item, i) => {
            const iconType = item.icon && IconOptions[item.icon].type === "pro"
                ? "glyphicon-pro"
                : "glyphicon";
            return (React.createElement(NavItem, { key: i, eventKey: item.name, disabled: item.disabled, onClick: item.onClick, id: item.id },
                item.icon && (React.createElement("span", { className: `icon ${iconType} ${iconType}-${IconOptions[item.icon].value} text-xl` })),
                item.label,
                type === "stacked" && item.extra && (React.createElement("span", { className: "tab-nav-item--extra" }, item.extra)),
                item.showWarning && (React.createElement(React.Fragment, null,
                    "\u00A0",
                    React.createElement("span", { role: "img", "aria-label": "Has missing or invalid fields", className: "icon glyphicon-pro glyphicon-pro-triangle-alert text-xl text-warning" })))));
        }),
        children));
};
export const TabContent = ({ children }) => {
    return React.createElement(BSTab.Content, { animation: false }, children);
};
export const TabPane = ({ children, name }) => {
    return React.createElement(BSTab.Pane, { eventKey: name }, children);
};
export const Tab = {
    Container: TabContainer,
    Menu: TabMenu,
    Pane: TabPane,
    Content: TabContent,
};
